


































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import FoldingCard from '@/components/FoldingCard.vue'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { dateTimeToDisplay } from '@/utils/dateTime'

import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'

import { quoteStatus, quoteStatusClass, quoteType } from '@/modules/Quote/helpers/quote'

@Component({
  components: {
    FoldingCard
  }
})
export default class ProducerDetailQuotes extends mixins(QuoteDialog, PolicyDialog) {
  @Prop({ type: Object as () => Producer }) readonly producer!: Producer

  quoteStatus = quoteStatus
  quoteStatusClass = quoteStatusClass
  quoteType = quoteType

  tableColumn = [
    { field: 'name',
      title: 'Quote Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'accountName',
      title: 'Account Name',
      slots: { default: 'account_name_default' },
      resizable: true
    },
    { field: 'contactName',
      title: 'Contact Name',
      slots: { default: 'contact_name_default' },
      resizable: true
    },
    { field: 'status', title: 'Quote Status', slots: { default: 'status_default' }, resizable: true },
    { field: 'type', title: 'Quote Type', slots: { default: 'type_default' } },
    { field: 'createdAt',
      title: 'Creation Time',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.createdAt ? dateTimeToDisplay(row.createdAt) : '-')
        ]
      }
      }
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 120 }
  ]

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  dateTimeToDisplay = dateTimeToDisplay

  get QuotesList () {
    return this.producer.quotes || []
  }

  routeToQuoteDetail (item: any) {
    this.$router.push({
      name: 'QuoteDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  routeToAllList () {
    this.$router.push({
      name: 'ProducerRelatedQuotesList',
      params: {
        id: this.producer.id + ''
      }
    })
  }

  routeToAccountDetail (item: any) {
    if (!item.account) {
      return
    }
    this.$router.push({
      name: 'AccountDetailDetail',
      params: {
        id: item.account.id
      }
    })
  }

  routeToContactDetail (item: any) {
    if (!item.primaryContact) {
      return
    }
    this.$router.push({
      name: 'ContactDetailDetail',
      params: {
        id: item.primaryContact.id
      }
    })
  }

  async deleteQuoteConfirm () {
    await this.deleteQuotePost()
    this.onSuccess()
  }
}
